import * as React from "react";
import type { SVGProps } from "react";
const SvgRecreationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      fillRule="evenodd"
      d="M17.116 3.205c0 .705.571 1.277 1.277 1.277h5.265a1.277 1.277 0 1 0 0-2.554h-.541a1.28 1.28 0 0 0-1.214-.878h-1.755c-.566 0-1.046.368-1.213.878h-.542c-.706 0-1.277.571-1.277 1.277m1.277.477a.478.478 0 0 1 0-.954h.878a.4.4 0 0 0 .4-.4c0-.264.213-.478.477-.478h1.755c.264 0 .478.214.478.478 0 .22.179.4.4.4h.877a.477.477 0 1 1 0 .954zM2.95 15.68a.4.4 0 0 1-.328-.63L8.15 7.153a.4.4 0 0 1 .671.024l1.153 1.922L13.4 3.403a.4.4 0 0 1 .685 0L17.511 9.1l1.153-1.922a.4.4 0 0 1 .671-.024l5.528 7.897a.4.4 0 0 1-.328.63h-8.818a.4.4 0 1 1 0-.8h4.338l-3.656-6.078-1.057 1.057a.4.4 0 0 1-.566 0l-1.033-1.033-1.034 1.033a.4.4 0 0 1-.565 0l-1.058-1.057L7.43 14.88h4.338a.4.4 0 0 1 0 .8zm8.561-7.585.916.916 1.033-1.034a.4.4 0 0 1 .565 0l1.034 1.034.915-.916-2.231-3.71zm9.478 6.785h2.778l-4.734-6.763-1.055 1.758zM9.506 9.875l-3.01 5.005H3.718l4.734-6.763zM15.052 23.865c0-.956.603-1.77 1.449-2.084l-.026-.154h-1.369l-.994 2.386a.4.4 0 0 1-.37.246h-1.334a2.223 2.223 0 1 1-1.274-2.472l.454-.681v-1.234h-.478a.4.4 0 0 1 0-.8h1.755a.4.4 0 0 1 0 .8h-.477v.955h3.9539999999999997l-.306-1.833H14.62a.4.4 0 0 1 0-.8h1.755a.4.4 0 0 1 .395.335l.519 3.114a2.222 2.222 0 1 1-2.237 2.221m2.595-.072a.4.4 0 1 1-.79.132l-.214-1.289a1.38 1.38 0 1 0 .787-.143zm-6.378-.767a1.306 1.306 0 1 1-.656-.458l-.713 1.07a.4.4 0 1 0 .666.443zm.525-.787.408-.612h2.037l-.763 1.832h-1.053a2.2 2.2 0 0 0-.63-1.22"
      clipRule="evenodd"
    />
    <path fill="#858585" d="M2 27.4h24v-.8H2z" />
    <path
      fill="#858585"
      fillRule="evenodd"
      d="M3.827 4.482a1.277 1.277 0 0 1 0-2.554h.542c.168-.51.647-.878 1.213-.878h1.755c.566 0 1.046.368 1.214.878h.541a1.277 1.277 0 1 1 0 2.554zM3.35 3.205c0 .264.214.477.477.477h5.265a.477.477 0 0 0 0-.954h-.877a.4.4 0 0 1-.4-.4.477.477 0 0 0-.478-.478H5.582a.477.477 0 0 0-.477.478.4.4 0 0 1-.4.4h-.878a.477.477 0 0 0-.477.477"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRecreationIcon;
